import * as React from 'react';
import * as styles from './LeadersSkeleton.css';
import { InlineText2 } from '@cian/ui-kit/typography';
import { mergeStyles } from '@cian/utils';
import { LeaderWrapper } from '../LeaderWrapper';

const LEADERS_STUB = Array.from({ length: 5 });

export const LeadersSkeleton = () => {
  return (
    <>
      {LEADERS_STUB.map((_, index) => (
        <LeaderWrapper key={index}>
          <InlineText2>{index + 1}.</InlineText2>

          <span {...mergeStyles(styles['skeleton'], styles['bet-skeleton'])} />
          <span {...mergeStyles(styles['skeleton'], styles['image-skeleton'])} />
        </LeaderWrapper>
      ))}
    </>
  );
};
